import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NegotiationStatusTypes } from '@app-model/evaluation';
import { EvaluationService } from '@app-services/evaluation.service';

@Component({
  selector: 'app-dialog-evaluation-negotiation-status',
  templateUrl: './dialog-evaluation-negotiation-status.component.html',
  styleUrls: ['./dialog-evaluation-negotiation-status.component.scss']
})
export class DialogEvaluationNegotiationStatusComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DialogEvaluationNegotiationStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private evaluationService: EvaluationService
    ){
      this.vechileId = data.vehicleId;
      this.statusSelected = data.negotiationStatus;
    }

  vechileId;
  statusSelected;

  loading = true;

  statuses = ["SOLD", "CONDITIONAL", "BLOCKED", "AVAILABLE_FOR_SALE", "AUCTION_IN_PROGRESS", "ALLOCATION"];
  ngOnInit() {
  }

  getStatus(reason: string) : string {
    return NegotiationStatusTypes.getLabel(reason);
  }

  onNoClick(): void {
    this.dialogRef.close({negotiationStatus: undefined});
  }

  @HostListener("window:keyup.esc")
  onKeyUp() {
      this.onNoClick();
  }

  onClickConfirm(): void {
    this.evaluationService.sendNegotiationStatus(this.vechileId, this.statusSelected).subscribe((response) => { this.dialogRef.close({ negotiationStatus: this.statusSelected}); return;});
  }

}
